import api from './api';

// const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000/api';

// // Create axios instance with default config
// const api = axios.create({
//   baseURL: API_URL,
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json',
//   },
// });

const providerService = {
  // Create provider
  createProvider: async (practiceId, providerData) => {
    const response = await api.post(`/practices/${practiceId}/providers`, providerData);
    return response;
  },

  // Get all providers for a practice
  getProviders: async (practiceId, params = {}) => {
    const response = await api.get(`/practices/${practiceId}/providers`, { params });
    return response;
  },

  // Get provider by ID
  getProvider: async (practiceId, providerId) => {
    const response = await api.get(`/practices/${practiceId}/providers/${providerId}`);
    return response;
  },

  // Update provider
  updateProvider: async (practiceId, providerId, providerData) => {
    const response = await api.put(`/practices/${practiceId}/providers/${providerId}`, providerData);
    return response;
  },

  // Delete provider
  deleteProvider: async (practiceId, providerId) => {
    const response = await api.delete(`/practices/${practiceId}/providers/${providerId}`);
    return response;
  }
};

export default providerService;
